export default __webpack_public_path__ + "static/media/star-unfilled.da862c9a.svg";